import {h} from 'preact';
import {box} from '../styles';
import {PageContent, NumberedHeading, RmaConfirmationItem} from '../components';
import {Link} from 'react-router-dom';

export const RepairsConfirmation = props => {
    return (
        <PageContent>
            <NumberedHeading step="1">Print your shipping labels</NumberedHeading>
            <p className="mt-2 max-w-lg leading-normal">Print the label(s) associated with each shipment below.</p>
            <NumberedHeading className="mt-8" step="2">Box your items</NumberedHeading>
            <p className="mt-2 max-w-lg leading-normal">Package your items as detailed below, then attach the
                appropriate shipping label to each box in your shipment.
                Remember to include any accessories that came with your equipment; e.g. batteries, power supply,
                etc.</p>
            <p className={`mt-2 max-w-lg leading-normal ${box.info}`}>Please remove ALL previous labels & stickers
                when packaging equipment. Only the UPS Label provided should be visible.</p>
            <div className="my-4">
                {props.rmas.map( ( rma, index, arr ) =>
                    <RmaConfirmationItem key={`${rma.placeId}-${index}`} rmaIndex={[index, arr.length]} {...rma}/>
                )}
            </div>
            <NumberedHeading className="mt-8" step="3">Ship your items with UPS</NumberedHeading>
            <p className="mt-2 max-w-lg leading-normal">Drop your shipment of at the nearest UPS location (be aware, if
                you schedule a pick-up
                with UPS you may incur additional charges, go to ups.com for shipping details).</p>
            <p className="mt-2 max-w-lg leading-normal">Once your equipment is received we will send you a confirmation
                email.</p>

            <div className="mt-12 flex justify-center">
                <Link to="/my-equipment" className="button primary mx-auto">Return to my equipment</Link>
            </div>
        </PageContent>
    );
};